module.exports = __webpack_public_path__ + "img/13_of_Diamonds.svg.fd1ddeb6.png";